import { render, staticRenderFns } from "./MyDeliveryAddresses.vue?vue&type=template&id=5a7aec90&"
import script from "./MyDeliveryAddresses.vue?vue&type=script&lang=js&"
export * from "./MyDeliveryAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports